import { TariffWithVerificationValues } from '@src/stores/product';

/**
 * Creates or updates verification values for a tariff
 */
export const createOrUpdateVerificationValues = (
  tariffWithVerificationValues: TariffWithVerificationValues,
  verificationId: string,
  value: string,
  tariffUnitIndex: number,
  verificationPosition: number,
): TariffWithVerificationValues => {
  // Create a copy of the tariff to avoid modifying the original object
  const oldTariff = { ...tariffWithVerificationValues };
  const verificationData = {
    tariffVerificationId: verificationId,
    tariffUnitIndex: tariffUnitIndex,
    verificationPosition: verificationPosition,
    value,
  };

  const newVerificationValues = Array.from(oldTariff.verificationValues!);

  const newVerificationIndex = newVerificationValues.findIndex(
    (verification) =>
      verification.tariffVerificationId === verificationId &&
      verification.tariffUnitIndex === tariffUnitIndex &&
      verification.verificationPosition === verificationPosition,
  );

  if (newVerificationIndex === -1) {
    newVerificationValues.push(verificationData);
  } else {
    newVerificationValues[newVerificationIndex] = {
      ...verificationData,
    };
  }

  const verificationValuesSorted = newVerificationValues.sort((a, b) => {
    // First sort by tariffUnitIndex
    if (a.tariffUnitIndex !== b.tariffUnitIndex) {
      return a.tariffUnitIndex - b.tariffUnitIndex;
    }
    // If tariffUnitIndex is equal, sort by verificationPosition
    return a.verificationPosition - b.verificationPosition;
  });

  // Create a new object with the updated verificationValues
  const updatedTariff = {
    ...oldTariff,
    verificationValues: verificationValuesSorted,
  };

  return updatedTariff;
};
